import React from 'react';
import styled from 'styled-components';

import Input from 'components/input';
import FormGroup from 'components/form-group';

export const Title = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.7em;
  text-align: center;
  margin-bottom: 20px;
`;
export const SubTitle = styled.div`
  font-weight: bold;
  font-size: 1.4em;
  margin-bottom: 10px;
  margin-top: 20px;
`;

const FieldWrapper = styled(FormGroup)`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: 1px;
  .group-label {
    font-size: 0.875em !important;
    font-weight: normal;
    color: #71828f;
    text-transform: uppercase;
    margin: 0;
    align-self: flex-start;
  }
  input {
    height: 50px;
    width: 100%;
    border-radius: 8px;
    border: solid 1px #d4dae1;
    background-color: #fff;
  }
  .disabled-input {
    height: 50px;
    width: 100%;
    border-radius: 8px;
    border: solid 1px #d4dae1;
  }
`;

export const FieldGroup = ({ label, errorText, className, children }) => {
  return (
    <FieldWrapper label={label} className={className} errorText={errorText}>
      {children}
    </FieldWrapper>
  );
};
